export default {
  en: require('./en.json'),
  es: require('./es.json'),
  tl: require('./tl.json'),
  zh: require('./zh.json')
}
